import { z } from "zod";
// Zoom Integration Types
export const ZoomStatusSchema = z.object({
    isConnected: z.boolean(),
    status: z.enum(["healthy", "unhealthy", "revoked"]).optional(),
    accountId: z.string().optional(),
    lastUpdated: z.string().optional(),
    zoomUserEmail: z.string().optional(),
});
export const ZoomAuthResponseSchema = z.object({
    url: z.string().url(),
});
// Integration Status Types (generic)
export const IntegrationStatusSchema = z.enum([
    "connected",
    "disconnected",
    "error",
    "pending",
    "revoked",
]);
